<template>
    <div class="collect-content full">
        <!-- 顶部栏优化：增加毛玻璃效果和精致阴影 -->
        <div class="top">
            <div class="title">
                <i class="el-icon-star-on title-icon"></i>
                我的收藏本
            </div>
            <div class="collapse-btn" @click="handleClose">
                <div class="fold-area">
                    <i class="el-icon-close close-btn"></i>
                </div>
            </div>
        </div>

        <div class="type-list">
            <!-- 题目收藏卡片 - 优化交互与视觉 -->
            <el-card class="box-card question-card" shadow="hover">
                <div slot="header" class="card-header">
                    <div class="header-left">
                        <i class="el-icon-tickets card-icon"></i>
                        <span>题目收藏</span>
                    </div>
                    <button class="view-btn" @click.stop="toggleQuestionOptions">
                        {{ showQuestionOptions ? '收起' : '查看' }}
                        <i :class="showQuestionOptions ? 'el-icon-arrow-up' : 'el-icon-arrow-right'"></i>
                    </button>
                </div>
                <transition name="fade-slide">
                    <div v-if="showQuestionOptions" class="question-options">
                        <button class="level-option-btn high" @click.stop="navigateToQuestionCollect('high')">
                            <i class="el-icon-star-off"></i>
                            高中题目
                        </button>
                        <button class="level-option-btn middle" @click.stop="navigateToQuestionCollect('middle')">
                            <i class="el-icon-reading"></i>
                            初中题目
                        </button>
                    </div>
                </transition>
            </el-card>

            <!-- 图谱收藏卡片 -->
            <el-card class="box-card" shadow="hover">
                <div slot="header" class="card-header">
                    <div class="header-left">
                        <i class="el-icon-share card-icon"></i>
                        <span>图谱收藏</span>
                    </div>
                    <button class="toggle-btn" @click.stop="choosedRobot('graphCollect')">
                        {{ graphShow ? '折叠' : '展开' }}
                        <i :class="graphShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    </button>
                </div>
                <transition name="fade-slide">
                    <div v-show="graphShow" class="graph-wrapper">
                        <div v-if="graphs && graphs.length" class="item-list">
                            <div v-for="(graph, index) in graphs" @click.stop="showGraph(graph)" :key="index" class="list-item"
                                :class="index % 2 === 0 ? 'even' : 'odd'">
                                <div class="item-index">{{ index + 1 }}</div>
                                <div class="item-content">
                                    <i class="el-icon-connection"></i>
                                    <span>{{ graph.kgid }}</span>
                                </div>
                                <i class="el-icon-right item-arrow"></i>
                            </div>
                        </div>
                        <div v-else class="empty-state">
                            <i class="el-icon-folder-empty"></i>
                            <span>暂无图谱收藏</span>
                        </div>
                    </div>
                </transition>
            </el-card>

            <!-- 试卷收藏卡片 -->
            <el-card class="box-card" shadow="hover">
                <div slot="header" class="card-header">
                    <div class="header-left">
                        <i class="el-icon-document card-icon"></i>
                        <span>试卷收藏</span>
                    </div>
                    <button class="toggle-btn" @click.stop="choosedRobot('paperCollect')">
                        {{ paperShow ? '折叠' : '展开' }}
                        <i :class="paperShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    </button>
                </div>
                <transition name="fade-slide">
                    <div v-show="paperShow" class="paper-wrapper">
                        <div v-if="papers && papers.length" class="item-list">
                            <div v-for="(paper, index) in papers" @click.stop="showPaper(paper)" :key="index" class="list-item"
                                :class="index % 2 === 0 ? 'even' : 'odd'">
                                <div class="item-index">{{ index + 1 }}</div>
                                <div class="item-content">
                                    <i class="el-icon-collection-tag"></i>
                                    <span>{{ paper.title.replaceAll("##", "") }}</span>
                                </div>
                                <i class="el-icon-right item-arrow"></i>
                            </div>
                        </div>
                        <div v-else class="empty-state">
                            <i class="el-icon-folder-empty"></i>
                            <span>暂无试卷收藏</span>
                        </div>
                    </div>
                </transition>
            </el-card>

            <!-- 专题收藏卡片 -->
            <el-card class="box-card" shadow="hover">
                <div slot="header" class="card-header">
                    <div class="header-left">
                        <i class="el-icon-folder-opened card-icon"></i>
                        <span>专题收藏</span>
                    </div>
                    <button class="toggle-btn" @click.stop="choosedRobot('topicCollect')">
                        {{ topicShow ? '折叠' : '展开' }}
                        <i :class="topicShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    </button>
                </div>
                <transition name="fade-slide">
                    <div v-show="topicShow" class="topic-wrapper">
                        <div v-if="topics && topics.length" class="item-list">
                            <div v-for="(topic, index) in topics" @click.stop="showTopic(topic)" :key="index" class="list-item"
                                :class="index % 2 === 0 ? 'even' : 'odd'">
                                <div class="item-index">{{ index + 1 }}</div>
                                <div class="item-content">
                                    <i class="el-icon-folder"></i>
                                    <span>{{ topic.title }}</span>
                                </div>
                                <i class="el-icon-right item-arrow"></i>
                            </div>
                        </div>
                        <div v-else class="empty-state">
                            <i class="el-icon-folder-empty"></i>
                            <span>暂无专题收藏</span>
                        </div>
                    </div>
                </transition>
            </el-card>
        </div>
    </div>
</template>

<script>
import robotMixin from "@/mixin/robot.js";
import { mapState } from "vuex/dist/vuex.common.js";
import pubsub from "pubsub-js";
import store from "@/store/index";

export default {
    data() {
        return {
            full: false,
            ele: null,
            showQuestionOptions: false,
        }
    },
    mixins: [robotMixin],
    props: ["showCollect"],
    computed: {
        ...mapState(["foldRobot"])
    },
    mounted() {
        this.ele = document.querySelector(".user-avatar");
        this.full = this.$attrs.full;
    },
    methods: {
        handleClose() {
            this.$router.go(-1);
        },
        toggleQuestionOptions() {
            if (!this.showQuestionOptions) {
                this.paperShow = false;
                this.graphShow = false;
                this.topicShow = false;
            }
            this.showQuestionOptions = !this.showQuestionOptions;
        },
        navigateToQuestionCollect(levelType) {
            const robotId = levelType === 'high' ? 'exercises' : 'mexercises';
            let sessionId = this.robotSessionMap[robotId];
            if (!sessionId) sessionId = +new Date() + "";
            this.$router.push(`/chatSearch/${robotId}/${sessionId.slice(-10)}`);
            if (this.isMobile) {
                store.commit("SET_FOLDROBOT", true);
                this.$emit("hideCollect");
            }
            pubsub.publish("getQuestionList", { type: "questionCollect" });
            this.showQuestionOptions = false;
        }
    }
}
</script>

<style lang="scss" scoped>
// 动画过渡
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.25s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}

.collect-content {
    width: 100vw;
    min-height: 100vh;
    // 护眼灰白色背景，避免纯白刺眼
    background: #f5f7fa;
    position: relative;
    padding-bottom: 30px;

    .top {
        position: sticky;
        top: 0;
        z-index: 10;
        // 半透明白色毛玻璃，柔和过渡
        background: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px 16px;
        margin-bottom: 8px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        
        .title {
            font-size: 18px;
            font-weight: 600;
            letter-spacing: 0.5px;
            // 深灰色文字，护眼且清晰
            background: linear-gradient(135deg, #2c3e50 0%, #1a2a3a 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            display: flex;
            align-items: center;
            gap: 8px;
            
            .title-icon {
                font-size: 20px;
                color:rgb(243, 239, 18);
                background: none;
                -webkit-background-clip: unset;
                background-clip: unset;
            }
        }
        
        .collapse-btn {
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            
            .fold-area {
                width: 32px;
                height: 32px;
                background: rgba(0, 0, 0, 0.05);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s;
                
                &:active {
                    background: rgba(0, 0, 0, 0.1);
                    transform: scale(0.95);
                }
                
                .close-btn {
                    font-size: 18px;
                    color: #5a6874;
                }
            }
        }
    }
    
    .type-list {
        padding: 0 12px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
}

// 卡片全局样式 - 自然阴影与柔和白色背景
.box-card {
    background: #ffffff;
    border-radius: 20px !important;
    border: none;
    // 多层次阴影，自然立体
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.03), 0 2px 6px rgba(0, 0, 0, 0.05);
    transition: all 0.3s cubic-bezier(0.2, 0, 0, 1);
    overflow: hidden;
    
    // 悬停时阴影加深，过渡自然
    &:hover {
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.02);
        transform: translateY(-2px);
    }
    
    &:active {
        transform: scale(0.99);
        box-shadow: 0 6px 14px rgba(0, 0, 0, 0.05);
    }
    
    ::v-deep .el-card__header {
        padding: 14px 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        
        .card-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            
            .header-left {
                display: flex;
                align-items: center;
                gap: 8px;
                
                .card-icon {
                    font-size: 18px;
                    color:rgb(64, 255, 137);
                }
                
                span {
                    font-size: 15px;
                    font-weight: 500;
                    color: #2c3e50;
                    letter-spacing: 0.3px;
                }
            }
            
            .view-btn,
            .toggle-btn {
                background: rgba(64, 255, 214, 0.1);
                border: none;
                padding: 5px 12px;
                border-radius: 30px;
                font-size: 12px;
                font-weight: 500;
                color:rgb(12, 179, 245);
                display: flex;
                align-items: center;
                gap: 4px;
                transition: all 0.2s;
                cursor: pointer;
                
                i {
                    font-size: 12px;
                    transition: transform 0.2s;
                }
                
                &:active {
                    background: rgba(64, 158, 255, 0.2);
                    transform: scale(0.96);
                }
            }
        }
    }
    
    ::v-deep .el-card__body {
        padding: 0;
        max-height: 36vh;
        overflow-y: auto;
        
        &::-webkit-scrollbar {
            width: 3px;
        }
        &::-webkit-scrollbar-track {
            background: #f0f0f0;
            border-radius: 10px;
        }
        &::-webkit-scrollbar-thumb {
            background: #cbd5e0;
            border-radius: 10px;
        }
    }
}

// 列表项样式 - 深灰色文字，柔和区分
.item-list {
    display: flex;
    flex-direction: column;
    
    .list-item {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        gap: 12px;
        transition: all 0.2s;
        cursor: pointer;
        
        &:hover {
            background: rgba(0, 0, 0, 0.02);
        }
        
        &:active {
            background: rgba(0, 0, 0, 0.04);
        }
        
        .item-index {
            width: 26px;
            font-size: 13px;
            font-weight: 500;
            color: #8a99aa;
        }
        
        .item-content {
            flex: 1;
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 14px;
            color: #334155;
            
            i {
                font-size: 16px;
                color: #7f8c8d;
            }
            
            span {
                word-break: break-word;
                line-height: 1.4;
            }
        }
        
        .item-arrow {
            font-size: 14px;
            color: #a0aec0;
            opacity: 0.7;
        }
        
        &.odd {
            background: rgba(0, 0, 0, 0.01);
        }
        
        &.even {
            background: transparent;
        }
    }
}

// 题目收藏选项区域
.question-options {
    display: flex;
    gap: 12px;
    padding: 14px 16px;
    background: #f8fafc;
    border-top: 1px solid rgba(0, 0, 0, 0.04);
    
    .level-option-btn {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 0;
        border: none;
        border-radius: 40px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s;
        
        i {
            font-size: 15px;
        }
        
        &.high {
            background: linear-gradient(135deg,rgb(158, 204, 250),rgb(64, 165, 248));
            color: white;
            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.25);
        }
        
        &.middle {
            background: linear-gradient(135deg,rgb(157, 252, 110),rgb(104, 207, 52));
            color: white;
            box-shadow: 0 4px 12px rgba(103, 194, 58, 0.2);
        }
        
        &:active {
            transform: scale(0.97);
            opacity: 0.9;
        }
    }
}

// 空状态样式 - 柔和灰色
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    gap: 12px;
    color: #94a3b8;
    
    i {
        font-size: 44px;
        opacity: 0.6;
    }
    
    span {
        font-size: 13px;
    }
}

// 移动端适配，保持舒适间距与字体
@media (max-width: 480px) {
    .collect-content .top .title {
        font-size: 17px;
    }
    
    .box-card ::v-deep .el-card__header .card-header .header-left span {
        font-size: 14px;
    }
    
    .list-item {
        padding: 10px 14px;
        
        .item-content {
            font-size: 13px;
        }
    }
}
</style>